<template>
  <div class="card floating" id="create-private-space">
    <img src="/img/icons/privateSpacesIcon/safebox-main-icon.svg">
    <h2 v-if="createMode == 1">{{ $t('buttons.modifyPrivateSpace') }}</h2>
    <h2 v-if="createMode == 2">{{ $t('prompts.privateSpaceModified') }}</h2>
    <input v-if="createMode == 1" class="input input--block" type="text" v-model="name" :placeholder="$t('prompts.folderName')" autocomplete="off" readonly onfocus="this.removeAttribute('readonly');">
    <div class="password" v-if="createMode == 1">
      <input class="input input--block" type="password" v-model="password" :placeholder="$t('login.password')" autocomplete="off" readonly onfocus="this.removeAttribute('readonly');">
      <input class="input input--block" type="password" v-model="passwordConfirm" :placeholder="$t('login.passwordConfirm')" autocomplete="off" readonly onfocus="this.removeAttribute('readonly');">
    </div>
    <div class="aviso" v-if="createMode == 2">
      <div class="texto">
        <img src="/img/icons/privateSpacesIcon/folder-alert-icon.svg">
        <p>{{ $t('prompts.secondLayerSecurity') }}<b>{{ $t('prompts.mustRemember') }}</b>{{ $t('prompts.accessAgain') }}<b class="red">{{ $t('prompts.loseCredentials') }}</b>{{ $t('prompts.ofYourInformation') }}<b class="green">{{ $t('prompts.keepSomewhereSafe') }}</b></p>
      </div>
      <button :aria-label="$t('prompts.downloadCredentials')" :title="$t('prompts.downloadCredentials')" @click="downloadCredentials">
        <img src="/img/icons/Multicuentas-icons/key-icon.svg">
        <span>{{ $t('prompts.downloadCredentials') }}</span>
      </button>
    </div>
    <div class="aceptar-condiciones" v-if="createMode == 2">
      <input type="checkbox" id="accept" name="accept" v-model="userAccepts" disabled=true>
      <label for="accept">{{ $t('prompts.labelConfirm') }}</label>
    </div>
    <div class="botones" v-if="createMode == 1">
      <button id="cancelButton" @click="$store.commit('closeHovers')" :aria-label="$t('buttons.cancel')" :title="$t('buttons.cancel')">
        <span>{{ $t('buttons.cancel') }}</span>
      </button>
      <button id="openButton" @click="modifyPrivateSpace" :aria-label="$t('buttons.modifyPrivateSpace')" :title="$t('buttons.modifyPrivateSpace')" :disabled="comprobarDatos">
        <span>{{ $t('buttons.modifyPrivateSpace') }}</span>
      </button>
    </div>
    <button v-if="createMode == 2" id="cancelButton" @click="accept" :aria-label="$t('buttons.accept')" :title="$t('buttons.accept')">
      <span>{{ $t('buttons.accept') }}</span>
    </button>
    <div class="dots">
      <span :class="[(createMode == 1 ? 'dot-active' : 'dot')]" ></span>
      <span :class="[(createMode == 2 ? 'dot-active' : 'dot')]"></span>
    </div>
    <div ref="recoveryKeyQr" style="display: none;">
      <qrcode-vue :value="recoveryKey" size="100" level="M"></qrcode-vue>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import QrcodeVue from 'qrcode.vue';
import jsPDF from 'jspdf';
import i18n from '@/i18n';
import moment from 'moment';
import { files as ibbapi } from '@/api';

export default {
  name: 'modify-private-space',
  components: {
    QrcodeVue
  },
  data: function () {
    return {
      name: '',
      password: '',
      passwordConfirm: '',
      userAccepts: true,
      handle: '',
      recoveryKey: '',
      createMode: 1
    };
  }, 
  computed: {
    comprobarDatos() {
      if (this.name !== '' && this.password !== '' && this.passwordConfirm !== '') {
        return false;
      } else {
        return true;
      }
    }
  },
  async mounted() {
    try {
      this.handle = this.$route.hash.slice(1);
      let openSecrets = await ibbapi.getOpenSecrets();
      for (let secret of openSecrets) {
        if (secret.handle === this.handle) {
          this.name = secret.name;
        }
      }
    } catch (e) {
      this.$showError(e);
    }
  },
  methods: {
    ...mapMutations(['closeHovers']),
    async downloadCredentials() {
      try {
        let action = await ibbapi.getUserInfo();
        let userEmail = action.userInfo.email;
        let userFirstname = action.userInfo.firstname;
        let userLastname = action.userInfo.lastname;

        this.recoveryKey = await ibbapi.getSecretRecoveryKey(this.handle);
        await this.$nextTick();

        let offset = 50;
        let doc = new jsPDF('p', 'pt');

        let img = new Image();
        img.src = '/img/icons/ibbFavicon_32.png';
        doc.addImage(img, 'PNG', 40, 33);

        let img2 = new Image();
        img2.src = '/img/icons/logo-2.png';
        doc.addImage(img2, 'JPEG', 390, 735, 200, 105);

        doc.text(i18n.t('recoveryPrivateSpace.documentTitle'), 80, offset);
        offset += 40;
        
        doc.setFontSize(12);
        doc.setFont(undefined, 'normal');
        let splitMessage = doc.splitTextToSize('            ' + i18n.t('recoveryPrivateSpace.documentDescription'), 500);
        doc.text(splitMessage, 40, offset);

        offset += 12 * splitMessage.length + 40;

        doc.setLineWidth(1.0); 
        doc.setDrawColor(0, 0, 0);
        doc.line(40, offset, 570, offset, 'S');
        offset += 40;

        doc.setFontSize(13);
        doc.setFont(undefined, 'normal');
        doc.text(i18n.t('recoveryPrivateSpace.documentFolderName'), 40, offset);

        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');
        doc.text(this.name, 180, offset);
        offset += 40;

        doc.setLineWidth(1.0); 
        doc.setDrawColor(0, 0, 0);
        doc.line(40, offset, 570, offset, 'S');
        offset += 40;

        doc.setFont(undefined, 'normal');
        doc.setFontSize(16);
        doc.text(i18n.t('recovery.documentKeyTitle'), 300, offset, null, null, 'center');
        offset += 50;

        doc.setFont(undefined, 'bold');
        doc.setFontSize(13);
        doc.text(this.recoveryKey, 300, offset, null, null, 'center');
        offset += 20;

        doc.addImage(this.$refs['recoveryKeyQr'].firstChild.firstChild.toDataURL('image/jpeg'), 250, offset, 100, 100);
        
        offset = 580;

        doc.setFont(undefined, 'bold');
        doc.setFontSize(11);
        splitMessage = doc.splitTextToSize(i18n.t('recoveryPrivateSpace.documentWarning'), 500);
        doc.text(splitMessage, 40, offset);
        offset += 35;

        doc.setFont(undefined, 'normal');
        doc.setFontSize(11);
        splitMessage = doc.splitTextToSize(i18n.t('recoveryPrivateSpace.documentStartRecovery'), 500);
        doc.text(splitMessage, 40, offset);
        offset += 35;

        doc.setFont(undefined, 'normal');
        doc.setFontSize(11);
        splitMessage = doc.splitTextToSize(i18n.t('recoveryPrivateSpace.documentImportant'), 500);
        doc.text(splitMessage, 40, offset);
        offset += 20;

        offset += 70;

        doc.setLineWidth(1.0); 
        doc.setDrawColor(0, 0, 0);
        doc.line(40, 700, 570, 700, 'S');

        doc.setFontSize(10);
        doc.text(i18n.t('recovery.documentSaveSecurely'), 40, 725);

        doc.setFontSize(11);
        doc.setFont(undefined, 'bold');
        doc.text(i18n.t('recovery.documentGeneratedBy'), 40, 755);
        doc.setFontSize(10);
        doc.text(userFirstname + ' ' + userLastname, 40, 755 + 30);
        doc.text(userEmail, 40, 755 + 45);

        doc.setFontSize(11);
        doc.setFont(undefined, 'bold');
        doc.text(i18n.t('recovery.documentDate'), 430, 750);

        doc.setFontSize(10);
        doc.text(moment().format('DD/MM/YYYY - HH:mm'), 470, 750);

        doc.save(i18n.t('recoveryPrivateSpace.documentName') + '.pdf');
      } catch (e) {
        this.$showError(e);
      }
    },
    async modifyPrivateSpace() {
      if (this.password === this.passwordConfirm) {
        let action = await ibb.updateSecret(this.handle, this.name, this.password);
        if (action.error.type === 1) {
          this.$showError(this.$t('prompts.incorrectData'));
        } else if (action.error.type === 7) {
          this.$showError(this.$t('prompts.alreadyExists'));
        } else if (!action.error.type) {
          this.handle = action.node.handle;
          this.createMode = 2;
        }
      } else {
        this.$showError(i18n.t('login.passwordsDontMatch'));
      }
    },
    accept() {
      this.$store.commit('setReload', true);
      this.$showSuccess(i18n.t('prompts.modifyPrivateSpaceSuccessfully'));
      this.$store.commit('closeHovers');
    }
  }
};
</script>